<template>
    <div class="manage-content">
        <h3 class="manage-title">基本信息</h3>
        <div class="white-bg shadow margin-top-20 margin-bottom-40 padding30 radius">
            <info :name="name"
                  :myMoney="myMoney"
                  :phone="phone"
                  :label="label"
                  :occupation_name="occupation_name"
                  :head_img="head_img">
            </info>
<!--            <div class="height1"></div>-->
            <balance :myMoney="myMoney"></balance>
        </div>
        <h3 class="manage-title">订单信息</h3>
        <div class="white-bg shadow margin-top-20 margin-bottom-20 padding30 radius">
            <extension-data :acceptNum="acceptNum"
                            :successNum="successNum"
                            :failNum="failNum">
            </extension-data>
            <div class="height1"></div>
            <underway :list="list" :count="count"></underway>
        </div>
    </div>
</template>
<script>
import {
    myDarenInfo,
    orderList
} from '@/config/api.js'
import Info from './components/Info'
import Balance from './components/Balance'
import ExtensionData from './components/ExtensionData'
import Underway from './components/Underway'
export default {
  name: 'DarenManage',
  components: {
    Info,
    Balance,
    ExtensionData,
    Underway
  },
    data () {
      return {
          name: '',
          myMoney: '',
          phone: '',
          label: '',
          head_img: '',
          acceptNum: '',
          successNum: '',
          failNum: '',
          occupation_name: '',
          list: [],
          count: ''
      }
    },
    methods: {
      getInfo () {
          let data = {
              user_type: this.$store.state.user_type,
              user_id: this.$store.state.user_id
          };
          this.$post(myDarenInfo, data)
              .then(res => {
                  const data = res.data;
                  this.area = data.area;
                  this.name = data.name;
                  this.myMoney = data.money;
                  this.phone = data.phone;
                  this.label = data.label;
                  this.head_img = data.head_img;
                  this.acceptNum = data.acceptNum;
                  this.successNum = data.successNum;
                  this.failNum = data.failNum;
                  this.occupation_name = data.occupation_name;
              })
              .catch(err => {
                  window.console.log(err)
              })
      },
      getOrder () {
          let data = {
              user_type: this.$store.state.user_type,
              page: 0,
              user_id: this.$store.state.user_id,
              type: 0
          };
          this.$post(orderList, data)
              .then(res => {
                  this.list = res.data.list;
                  this.count = res.data.count
              })
              .catch(err => {
                  window.console.log(err)
              })
    }
    },
    created() {
      this.getInfo();
      this.getOrder()
    }
}
</script>
